/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import permissions from '../../../common/constants/permissions';

import './confirm.tpl.html';
import * as _l from 'lodash';

angular
  .module('bulkRestore.confirm', ['ngSanitize', 'services.bulkrestore', 'services.error', 'services.permissions'])
  /**
   * Tab items for bulk restore confirm page
   */
  .constant(
    'BulkRestoreConfirmTabs',
    Object.freeze({
      ITEMS: 1,
      OVERWRITE_VALUES: 2,
      SPECIFIC_FIELDS: 3,
      OBJECTS: 4
    })
  )
  /**
   * These keys are used for sorting the records
   */
  .constant(
    'SortKeys',
    Object.freeze({
      NAME: 'sfName'
    })
  )
  /**
   * Controller for the bulkRestore.confirm template.
   */
  .controller('RestoreConfirmCtrl', [
    '$scope',
    '$filter',
    '$state',
    '$rootScope',
    '$q',
    '$timeout',
    'WizardService',
    'BulkRestoreService',
    'ErrorService',
    'MomentFormats',
    'SortKeys',
    'pagingUtils',
    'progressFactory',
    'BulkRestoreConfirmTabs',
    'BULK_RESTORE_EVENTS',
    'BULK_RESTORE_CHILD_STRATEGIES',
    'confirmModalUtils',
    'permissionService',
    'SOBJECT_STATE',
    'configService',
    function (
      $scope,
      $filter,
      $state,
      $rootScope,
      $q,
      $timeout,
      WizardService,
      BulkRestoreService,
      ErrorService,
      MomentFormats,
      SortKeys,
      pagingUtils,
      progressFactory,
      BulkRestoreConfirmTabs,
      BULK_RESTORE_EVENTS,
      BULK_RESTORE_CHILD_STRATEGIES,
      confirmModalUtils,
      permissionService,
      SOBJECT_STATE,
      configService
    ) {
      if (!$state.params.bulkRestoreData) {
        throw new Error('bulkRestoreData is required');
      }

      var i18n = $filter('i18n');
      var pluralize = $filter('pluralize');
      var bulkRestoreData = $state.params.bulkRestoreData;

      var model;

      // Published functions
      $scope.canIncludeChildren = canIncludeChildren;
      $scope.getPageTitle = getPageTitle;
      $scope.getConfirmSummary = getConfirmSummary;
      $scope.getDateTime = getDateTime;
      $scope.getHeaderClass = getHeaderClass;
      $scope.getIncludeChildrenSummary = getIncludeChildrenSummary;
      $scope.getObjectTypeString = getObjectTypeString;
      $scope.getOverwriteValuesSummary = getOverwriteValuesSummary;
      $scope.sortRecords = sortRecords;
      $scope.getSpecificFieldsSummary = getSpecificFieldsSummary;
      $scope.getStatus = getStatus;
      $scope.handleError = handleError;
      $scope.handleResponse = handleResponse;
      $scope.hasOverwriteValues = hasOverwriteValues;
      $scope.hasSpecificFields = hasSpecificFields;
      $scope.isTabSelected = isTabSelected;
      $scope.restoreOrExport = restoreOrExport;
      $scope.showTab = showTab;
      $scope.updateRecords = updateRecords;
      $scope.showMask = {};

      $scope.bulkRestoreData = bulkRestoreData;
      $scope.BulkRestoreConfirmTabs = BulkRestoreConfirmTabs;
      $scope.SortKeys = SortKeys;
      $scope.isShowChildren = isShowChildren;
      $scope.showOrHideChildren = showOrHideChildren;
      $scope.getChildren = getChildren;
      $scope.loadChildren = loadChildren;
      $scope.objectRestoreType = bulkRestoreData.getObjectRestoreType();
      $scope.BULK_RESTORE_CHILD_STRATEGIES = BULK_RESTORE_CHILD_STRATEGIES;

      configService.getConfig().then((config) => {
        $scope.searchSortAvailable = config.searchSortAvailable;
      });
      bulkRestoreData.setSortBy(null);
      bulkRestoreData.setAscending(null);

      let showChildrenMap;

      // To each entry add a summary string showing the configured field names
      _.each(bulkRestoreData.getSpecificFieldEntries(), function (sfEntry) {
        sfEntry.fieldNamesStr = sfEntry.objectFields.join(', ');
      });

      const pageSize = 20;

      const csvResultPagingParams = pagingUtils.pagingInfo.bulkRestoreSelectedRecords;
      csvResultPagingParams.totalItems = bulkRestoreData.getSelectedObjectRecordCount();
      csvResultPagingParams.totalPages = Math.ceil(
        csvResultPagingParams.totalItems / csvResultPagingParams.itemsPerPage
      );
      csvResultPagingParams.currentPage = 1;
      csvResultPagingParams.page = csvResultPagingParams.currentPage - 1;
      bulkRestoreData.setSearchPageToken(null);
      bulkRestoreData.setSearchPageBatchId(null);
      bulkRestoreData.setSearchToken(null);

      const selectedObjectTypes = bulkRestoreData.getSelectedObjectTypes();

      // Store data in a model object rather than the scope itself for easier watching
      $scope.model = model = {
        isCsvVerifiedRestore: bulkRestoreData.isRestoreFromCsv(),
        currentTab: selectedObjectTypes ? BulkRestoreConfirmTabs.OBJECTS : BulkRestoreConfirmTabs.ITEMS,
        selectedRecords: [],
        selectedObjectTypes,
        lastPage: true
      };

      initWizardPage();

      // Get the records to display
      $scope.updateRecords();

      /**
       * Sets up this page for use with the wizard service.
       */
      function initWizardPage() {
        // Register our page with the wizard service
        var page = WizardService.getCurrentPage();
        page.setHeaderText(i18n('CONFIRM_CHANGES'));
        page.setStateParams($state.params);
        page.setValid(true); // There are no settings on this page so its always valid
        // For the purposes of confirming cancellation of the wizard we'll consider the wizard touched if we get this
        // far.
        page.setTouched(true);

        // Add a custom button to the wizard to handle Export
        var exportButton = page.addCustomButton();
        exportButton.setTextKey('EXPORT');
        exportButton.setTooltipKey('EXPORT');
        exportButton.setEnabled(function () {
          return !progressFactory.bulkRestorePreviewInProgress;
        });
        exportButton.setClick(function () {
          var isExport = true;
          return restoreOrExport(isExport);
        });
        exportButton.setVisible(false);
        permissionService.hasPermission(permissions.EXPORT).then((hasPermission) => {
          if (hasPermission) {
            exportButton.setVisible(true);
            $timeout(function () {
              $scope.$apply();
            });
          }
        });

        // Add a custom button to the wizard to handle Restore
        var restoreButton = page.addCustomButton();
        restoreButton.setTextKey('RESTORE');
        restoreButton.setTooltipKey('RESTORE_NOW');
        restoreButton.setEnabled(function () {
          return !progressFactory.bulkRestoreInProgress;
        });
        restoreButton.setClick(function () {
          return confirmModalUtils
            .openConfirmModal({
              titleTextKey: 'CONTINUE',
              confirmTextKey: 'OBJECT_RESTORE_CONFIRMATION'
            })
            .then((isConfirmed) => {
              if (isConfirmed) {
                const isExport = false;
                return restoreOrExport(isExport);
              }

              return false;
            });
        });

        restoreButton.setVisible(false);
        permissionService.hasPermission(permissions.RESTORE).then((hasPermission) => {
          if (hasPermission) {
            restoreButton.setVisible(true);
            $timeout(function () {
              $scope.$apply();
            });
          }
        });
      }

      /**
       * Function to determine if item is selected.
       * @param {Number} tab - The tab to check if its the current one.
       * @returns {Boolean} - Flag if the item is selected or not.
       */
      function isTabSelected(tab) {
        return model.currentTab === tab;
      }

      /**
       * Function to show the correct content for the selected tab.
       * @param {Number} tab - The tab to set to the current tab.
       */
      function showTab(tab) {
        model.currentTab = tab;
      }

      /**
       * Displays the next page of selected records.
       *
       * @returns Promise - a promise that resolves when the update completes.
       */
      function updateRecords() {
        if (bulkRestoreData.checkObjectTypeSelectedCount(1)) {
          return;
        }

        // See if we can use the selected records in the bulk restore data.
        if (bulkRestoreData.canGetSelectedObjectRecords()) {
          const pageToken = bulkRestoreData.getSearchPageToken();
          let records = bulkRestoreData.getSelectedObjectRecords();
          if (!records.length) {
            return Promise.resolve();
          }

          const sortBy = bulkRestoreData.getSortBy();
          const ascending = bulkRestoreData.getAscending();
          records = _l.orderBy(records, sortBy ? sortBy : 'id', ascending ? 'asc' : 'desc');
          if (pageToken) {
            records = records.filter((record) => record.id > pageToken);
          }
          records = records.slice(0, pageSize);

          model.lastPage = records.length < pageSize;

          applySelectedRecords(records);
          bulkRestoreData.setSearchPageToken(_l.last(model.selectedRecords).id);
          return Promise.resolve();
        }
        $rootScope.showLoadingMask = true;

        let getRecordsPromise;
        if (bulkRestoreData.isRestoreFromCsv()) {
          getRecordsPromise = BulkRestoreService.getCsvVerificationResults(bulkRestoreData, csvResultPagingParams);
        } else {
          getRecordsPromise = BulkRestoreService.searchRecordsPage(bulkRestoreData, pageSize);
        }

        return getRecordsPromise
          .then(function (results) {
            const selectedRecords = bulkRestoreData.checkAndMarkRecordsAreIncludingChildren(results.records);
            applySelectedRecords(selectedRecords);
            if (bulkRestoreData.isRestoreFromCsv()) {
              csvResultPagingParams.totalItems = results.numberOfRecords;
              csvResultPagingParams.totalPages = Math.ceil(
                csvResultPagingParams.totalItems / csvResultPagingParams.itemsPerPage
              );
              model.lastPage = selectedRecords.length < csvResultPagingParams.pageSize;
              csvResultPagingParams.page++;
            } else {
              model.lastPage = selectedRecords.length < pageSize;
              if (results.searchToken) {
                bulkRestoreData.setSearchToken(results.searchToken);
              }
              if (results.records.length > 0) {
                bulkRestoreData.setSearchPageToken(results.pageToken);
                bulkRestoreData.setSearchPageBatchId(results.pageBatchId);
              }
            }
          })
          .catch(function (err) {
            ErrorService.report(err, i18n('DELETED_ITEMS_RECORDS_FAILED'));
          })
          .finally(function () {
            $rootScope.showLoadingMask = false;
          });
      }

      /**
       * Apply new selected records set to controller and view
       */
      function applySelectedRecords(selectedRecords) {
        clearShowChildrenMap();
        model.selectedRecords.push(...selectedRecords);
      }

      /**
       * Utility to get the confirm page title.
       *
       * @return {string} - The title of the confirm page.
       */
      function getPageTitle() {
        let title;
        if (!selectedObjectTypes) {
          let objectType = getObjectTypeString();
          const recordsToRestoreCount = bulkRestoreData.getSelectedObjectRecordsCountInfo();

          if (recordsToRestoreCount.count === 1) {
            title = i18n('CONFIRM_RESTORE_RECORD', objectType);
          } else {
            title = i18n('CONFIRM_RESTORE_RECORDS', [recordsToRestoreCount.text, objectType]);
          }
        } else {
          if (selectedObjectTypes.selectedAll) {
            title = i18n('ALL_OBJECTS');
          } else {
            const selectedMultipleObjects = bulkRestoreData.checkObjectTypeSelectedCount(2);
            title = selectedMultipleObjects
              ? i18n('CONFIRM_RESTORE_OBJECTS', [
                  selectedObjectTypes.selectedList.length,
                  selectedObjectTypes.selectedList.join(', ')
                ])
              : i18n('CONFIRM_RESTORE_OBJECT', [selectedObjectTypes.selectedList[0]]);
          }
        }
        return title.trim();
      }

      /**
       * Utility to get the confirm page summary.
       *
       * @return {string} - The summary of the bulk restore wizard.
       */
      function getConfirmSummary() {
        const selectedObjectRecords = bulkRestoreData.getSelectedObjectRecords(true);
        const length = Array.isArray(selectedObjectRecords) ? selectedObjectRecords.length : 0;

        var recordsStr = pluralize(length, 'RECORD', 'RECORDS');
        var destinationText, summary, destSfOrgId;

        if (bulkRestoreData.isCrossOrgRestore()) {
          destinationText = bulkRestoreData.getDestOrgName();
          destSfOrgId = bulkRestoreData.getDestOrgSfId();
          if (destSfOrgId) {
            destinationText += ' (' + destSfOrgId + ')';
          }
        } else {
          destinationText = i18n('THIS_ORG').toLowerCase();
        }

        const recordsToRestoreCount = bulkRestoreData.getSelectedObjectRecordsCountInfo();

        if (!selectedObjectTypes) {
          summary = i18n('RESTORING_RECORDS_TO_ORG', [
            recordsToRestoreCount.text,
            getObjectTypeString(),
            recordsStr.toLowerCase(),
            destinationText
          ]);
        } else {
          summary = i18n('RESTORING_OBJECTS_TO_ORG', [getPageTitle(), destinationText]);
        }
        return summary;
      }

      /**
       * Returns a string describing the selected object type(s).
       *
       * @returns {string} a comma-separated list of the selected object types.
       */
      function getObjectTypeString() {
        if (bulkRestoreData.isRestoreFromCsv()) {
          return bulkRestoreData.getSelectedObjectRecordTypes().join(',');
        } else {
          return bulkRestoreData.getSearchObjectType();
        }
      }

      /**
       * Utility method to check if we have overwrite values.
       *
       * @returns {boolean} - If we have overwrite values or not.
       */
      function hasOverwriteValues() {
        return bulkRestoreData.isOverwritingValues() && bulkRestoreData.getOverwriteValueEntryCount() > 0;
      }

      /**
       * Utility method to check if we have specific fields.
       *
       * @returns {boolean} - If we have specific fields or not.
       */
      function hasSpecificFields() {
        return bulkRestoreData.isSpecifyingFields() && bulkRestoreData.getSpecificFieldEntryCount() > 0;
      }

      /**
       * Returns a string describing the inclusion of children of deleted records.
       *
       * @returns {string} - The summary of the include children action.
       */
      function getIncludeChildrenSummary() {
        let settingTypeStr = i18n('INCLUDE_CHILDREN').toLowerCase().trim();
        let notStr = bulkRestoreData.isIncludingAnyChildren() ? '' : i18n('NOT').toLowerCase();
        return i18n('RECORDS_SETTING_SUMMARY', [notStr, settingTypeStr]);
      }

      /**
       * Utility method to get the overwrite values string.
       *
       * @returns {string} - The summary of the overwrite values
       */
      function getOverwriteValuesSummary() {
        var count = bulkRestoreData.getOverwriteValueEntryCount();
        var summary;

        if (count === 1) {
          summary = i18n('OVERWRITE_SUMMARY_SINGULAR');
        } else {
          summary = i18n('OVERWRITE_SUMMARY', [count]);
        }

        return summary;
      }

      /**
       * Utility method to get the specific fields string.
       *
       * @returns {string} - The summary of the specific fields
       */
      function getSpecificFieldsSummary() {
        var count = _l.sumBy(bulkRestoreData.getSpecificFieldEntries(), (sfEntry) => _.size(sfEntry.selectedValues));
        var summary;

        if (count === 1) {
          summary = i18n('SPECIFIC_FIELDS_SUMMARY_SINGULAR');
        } else {
          summary = i18n('SPECIFIC_FIELDS_SUMMARY', [count]);
        }

        return summary;
      }

      /**
       * Returned the formatted dateTime string from a record object.
       *
       * @param {string} recordDate - A string date.
       * @returns {string} - A formatted date string.
       */
      function getDateTime(recordDate) {
        return moment(recordDate).format(MomentFormats.BATCH);
      }

      /**
       * Returned the status for the record object.
       *
       * @param {object} record - the record object.
       * @returns {string} - the status.
       */
      function getStatus(record) {
        if (bulkRestoreData.isManualObjectBrowse()) {
          return i18n('IN_BACKUP');
        }
        let searchObjectStates = bulkRestoreData.getSearchObjectStates();
        if (record && record.isDeleted) {
          return i18n('DELETED');
        }
        if (searchObjectStates.indexOf(SOBJECT_STATE.UPDATED) >= 0) {
          return i18n('UPDATED');
        }
        if (searchObjectStates.indexOf(SOBJECT_STATE.NEW) >= 0) {
          return i18n('NEW_OR_UPDATED');
        }
        if (searchObjectStates.indexOf(SOBJECT_STATE.UNCHANGED) >= 0) {
          return i18n('UNCHANGED');
        }
        if (searchObjectStates.indexOf(SOBJECT_STATE.DELETED) >= 0) {
          return i18n('DELETED');
        }
        return i18n('UPDATED');
      }

      /**
       * Sorts the object records by the specified key.
       *
       * @param {string} sortKey - The sort key.
       */
      function sortRecords(sortKey) {
        if (!$scope.searchSortAvailable) {
          return;
        }
        if (bulkRestoreData.getSortBy() !== sortKey) {
          // Start with ascending when we switch to a new column
          bulkRestoreData.setSortBy(sortKey);
          bulkRestoreData.setAscending(true);
          csvResultPagingParams.sort = sortKey;
          csvResultPagingParams.ascending = true;
        } else {
          // Toggle the direction when we stay on the same column
          bulkRestoreData.setAscending(!bulkRestoreData.getAscending());
          csvResultPagingParams.ascending = !csvResultPagingParams.ascending;
        }

        bulkRestoreData.setSearchPageToken(null);
        bulkRestoreData.setSearchPageBatchId(null);
        bulkRestoreData.setSearchToken(null);
        model.selectedRecords = [];

        return $scope.updateRecords();
      }

      /**
       * Returns the class to be used to style a header in the record list.
       *
       * @param {string} sortKey - The sort key used to identify the header.
       * @returns {string} The class to use.
       */
      function getHeaderClass(sortKey) {
        let headerClass = '';
        if (bulkRestoreData.getSortBy() === sortKey && $scope.searchSortAvailable) {
          if (bulkRestoreData.getAscending()) {
            headerClass = 'sbsf-log-header-asc sca-icon-down-black';
          } else {
            headerClass = 'sbsf-log-header-desc sca-icon-down-black';
          }
        }
        return headerClass;
      }

      /**
       * Queues a restore or an export.
       *
       * @param {boolean} isExport - true if we're exporting, false if we're restoring
       * @returns {Promise} a promise that is resolved with one of the following:
       *   1) true if the wizard can be dismissed
       *   2) false if the wizard should remain
       *   3) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function restoreOrExport(isExport) {
        var promise;

        $rootScope.showLoadingMask = true;

        if (isExport) {
          promise = BulkRestoreService.submitExport(bulkRestoreData);
        } else {
          promise = BulkRestoreService.submitRestore(bulkRestoreData);
        }

        return promise
          .then(function (res) {
            return $scope.handleResponse(isExport, res);
          })
          .catch(function (err) {
            return $scope.handleError(isExport, err);
          })
          .finally(function () {
            $rootScope.showLoadingMask = false;
          });
      }

      /**
       * Handles a response from submitting the operation.
       *
       * @param {boolean} isExport - true if we're exporting, false if we're restoring
       * @param {object} res - the response object.
       * @returns {boolean|object} one of the following:
       *   1) true if the wizard can be dismissed
       *   2) false if the wizard should remain
       *   3) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function handleResponse(isExport, res) {
        // Status of 1 indicates a failure
        if (res.status === 1) {
          return $scope.handleError(isExport, res.message);
        }

        // The operation succeeded
        if (isExport) {
          progressFactory.bulkRestorePreviewInProgress = true;
        } else {
          progressFactory.bulkRestoreInProgress = true;
        }

        return true; // We're done with the wizard
      }

      /**
       * Handles an error from restoreOrExport.
       *
       * @param {boolean} isExport - true if we're exporting, false if we're restoring
       * @param {object|string} err - the error object or message.
       * @returns {boolean|object} one of the following:
       *   1) false if the wizard should remain
       *   2) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function handleError(isExport, err) {
        var msg;
        if (typeof err === 'string') {
          msg = err;
        } else if (err && err.message) {
          msg = err.message;
        } else if (err && err.data && err.data.message) {
          msg = err.data.message;
        }

        // If the error message contains access_token_owner_id, we know that access_token_owner_id on auth_info does
        // not match access_token_owner_id that created the auth row.
        // Handle differently by showing modal.
        if (msg && msg.indexOf('access_token_owner_id') > -1) {
          // Return parameters to indicate we need an error popup
          return {
            showConfirm: true,
            confirmTextKey: 'ACCESS_TOKEN_OWNER_ID_ERROR',
            confirmButtonTextKey: 'GO_TO_DASHBOARD',
            extraHeight: true
          };
        }

        // We don't recognize the message
        var fallbackMsg = isExport ? i18n('BULK_RESTORE_PREVIEW_SUBMIT_FAILED') : i18n('BULK_RESTORE_SUBMIT_FAILED');
        ErrorService.report(msg, fallbackMsg);
        return false; // Didn't succeed, but we don't need the wizard to display the message.
      }

      /**
       * Determines whether the option to include children in the restore should be shown
       *
       * @returns {boolean} true if the option should be shown.
       */
      function canIncludeChildren() {
        // Always show this for CSV uploads
        if (bulkRestoreData.isRestoreFromCsv()) {
          return true;
        }

        // We only show the option if the selected records contain any deleted records
        return bulkRestoreData.hasSelectedDeletedObjects();
      }

      /**
       * Determines whether the option to include children in the restore should be shown
       *
       * @returns {boolean} true if the list of children should be shown.
       */
      function isShowChildren(index) {
        return !!showChildrenMap[index];
      }

      /**
       * Toggles visibility of children objects list
       */
      function showOrHideChildren(index) {
        showChildrenMap[index] = !$scope.isShowChildren(index);
      }

      /**
       * Gets children objects list
       * @param {string} recordId
       * @return {object}
       */
      function getChildren(recordId) {
        return bulkRestoreData.childRecords[recordId];
      }

      /**
       * Loads children objects list from server
       * @param {object} record
       * @return {Promise | undefined}
       */
      function loadChildren(record) {
        if ($scope.getChildren(record.recordId)) {
          return;
        }

        $scope.showMask[record.recordId] = true;
        return BulkRestoreService.getObjectRecordPreviewChildren(record.recordId, record.recordBatchId)
          .then((children) => {
            bulkRestoreData.childRecords[record.recordId] = bulkRestoreData
              .transformPlateIntoTree(children)
              .map((item) => {
                item.isSelected = false;
                item.includeChildren = record.includeChildren;
                return item;
              });
          })
          .catch(function (err) {
            ErrorService.report(err, i18n('DELETED_ITEMS_PREVIEW_DESCENDANTS_FAILED'));
          })
          .finally(() => {
            $scope.showMask[record.recordId] = false;
          });
      }

      /**
       * Clear show children map to hide all children on the page
       */
      function clearShowChildrenMap() {
        showChildrenMap = {};
      }
    }
  ]);
